module.exports = __webpack_public_path__ + "static/media/photo_wrong_example2.8df12044.JPG";